import React from "react";

const CashTabsComponentLoadable = React.lazy(() => import("./CashTabsComponent"));

export { CashTabsComponentLoadable };

